// Slick init + popovers + prev/next week navigation for the server-rendered timetable schedule
// (the header timetable dropdown AND the full "לוח שידורים" page). Mirrors the deleted Angular
// dates-carousel / programmes-carousel components and jquery.service.ts:
//
//  - two jQuery-slick carousels linked via `asNavFor` (7 day columns on desktop, 1 on mobile);
//  - a bootstrap popover per programme box (.popover1) showing the .popoverContent on hover (≥1200);
//  - prev/next arrows that fetch the adjacent week's _SiteSchedule partial and swap it in
//    (replacing the Angular getPrev/getNextTimetable AJAX, which hit the now-deleted timetable API).
//
// Everything is scoped per <schedule> element: a page can carry two schedules (header dropdown +
// page body), so asNavFor and the nav must target THIS schedule's own carousels.

const POPOVER_TEMPLATE =
  '<div class="popover mainPopover" role="tooltip"><div class="arrow"></div><div class="popover-content"></div></div>';

function slickOptions(asNavFor, currentDay) {
  // Exact options from dates-carousel.component.ts / programmes-carousel.component.ts.
  return {
    rtl: true,
    arrows: false,
    infinite: false,
    speed: 1000,
    slidesToShow: 7,
    slidesToScroll: 7,
    asNavFor,
    responsive: [
      { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1, speed: 300, initialSlide: currentDay } }
    ]
  };
}

function currentDayIndex($days, $progs) {
  const onAirDay = $progs.children().toArray().findIndex(day => day.querySelector('li.active'));
  return onAirDay >= 0 ? onAirDay : Math.max($days.children('.active').index(), 0);
}

function initSlick(sched) {
  const $ = window.jQuery;
  const $days = $(sched).find('.daysCarousel');
  const $progs = $(sched).find('.programCarousel');
  if (!$days.length || !$progs.length) return;
  if ($progs.hasClass('slick-initialized') || $days.hasClass('slick-initialized')) return;
  const currentDay = currentDayIndex($days, $progs);
  $progs.slick(slickOptions($days, currentDay));
  $days.slick(slickOptions($progs, currentDay));

  // Inits while hidden (header dropdown) cache a 0-width track — recompute once layout settles.
  const refresh = () => { $progs.slick('setPosition'); $days.slick('setPosition'); };
  requestAnimationFrame(refresh);
  window.addEventListener('load', refresh);
}

// Bootstrap popover on each programme box, content = the box's sibling .popoverContent.
// Desktop only (≥1200), shown on hover with a grace period — mirror of jquery.service.ts.
function initPopovers(sched) {
  const $ = window.jQuery;
  if (!$ || !$.fn || !$.fn.popover) return;

  const $boxes = $(sched).find('.popover1');
  $boxes.popover({
    html: true,
    container: 'body',
    placement: 'auto left', // legacy .popover1 used mainPopover + 'auto left' (arrow only styled for left/right)
    trigger: 'manual',
    template: POPOVER_TEMPLATE,
    content() { return $(this).next().html(); }
  });

  if (document.body.scrollWidth < 1200) return;

  $boxes
    .on('mouseenter.sched focus.sched', function () {
      const box = this;
      $(box).popover('show');
      $('.popover').off('mouseleave.sched').on('mouseleave.sched', () => $(box).popover('hide'));
    })
    .on('mouseleave.sched blur.sched', function () {
      const box = this;
      setTimeout(() => { if (!$('.popover:hover').length) $(box).popover('hide'); }, 300);
    });
}

let navToken = 0;
async function navigate(sched, dir) {
  const $ = window.jQuery;
  if (sched.dataset.loading === '1') return;

  const current = parseInt(sched.dataset.slideIndex || '0', 10);
  const target = current + dir;
  const isGlz = sched.dataset.isglz === 'true';
  const showLinks = sched.dataset.showLinks === 'true';
  const url = `/umbraco/surface/TimeTableSurface/Schedule?isGlz=${isGlz}&slideIndex=${target}&showLinks=${showLinks}`;

  sched.dataset.loading = '1';
  const token = ++navToken;
  try {
    const html = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(r => r.text());
    if (token !== navToken) return; // superseded by a newer click
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const next = tmp.querySelector('schedule');
    // Ignore empty weeks (e.g. navigating past the available data) — stay on the current one.
    if (!next || !next.querySelector('.programCarousel .name')) return;

    next.dataset.slideIndex = String(target);
    $('.popover').remove(); // drop any popover left on <body> by the outgoing schedule
    sched.replaceWith(next);
    initOne(next);
  } catch {
  } finally {
    sched.dataset.loading = '0';
  }
}

function wireArrows(sched) {
  if (sched.dataset.navWired === '1') return;
  sched.dataset.navWired = '1';
  const prev = sched.querySelector('.slick-prev.navArrow'); // getPrevTimetable → earlier week
  const next = sched.querySelector('.slick-next.navArrow'); // getNextTimetable → later week
  if (prev) prev.addEventListener('click', () => navigate(sched, -1));
  if (next) next.addEventListener('click', () => navigate(sched, +1));
}

function initOne(sched) {
  initSlick(sched);
  initPopovers(sched);
  wireArrows(sched);
}

function scrollToCurrentHour(sched) {
  const $progs = window.jQuery(sched).find('.programCarousel.slick-initialized');
  const currentHour = sched.querySelector('.subMenu.v2 li.active');
  if (!currentHour || !$progs.length || !sched.getClientRects().length) return;
  if ($progs.slick('getSlick').activeBreakpoint === null) return;
  requestAnimationFrame(() => currentHour.scrollIntoView({ block: 'center' }));
}

export function initSchedule() {
  const $ = window.jQuery;
  if (!$ || !$.fn || !$.fn.slick) return;
  const schedules = document.querySelectorAll('schedule');
  schedules.forEach(initOne);
  schedules.forEach(scrollToCurrentHour);
}
